export default __webpack_public_path__ + "static/media/menu.bc7e4132.png";